
import './index.css'

const LogoWrapper = ({ children, bgcolor = 'white' }) => { 
    return (
      <div className="logo-wrapper" style={{ background: bgcolor }}>
        {children}
      </div>
    );
}

export default LogoWrapper;